export const headings = [
  { name: "User" },
  { name: "Status" },
  { name: "Action", align: "right" },
];
